function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

if (!customElements.get('product-sets')) {

  /**
   * ProductSets
   * @description Handles the submit of product sets.
   */
  class ProductSets extends HTMLElement {

    constructor() {
      super();

      // Select other web components by id.
      this.quickshopDrawer = document.getElementById('quickshop-drawer');
      this.cartDrawer = document.querySelector('cart-drawer');

      // Get the form
      this.form = this.querySelector('form');

      // Catch the submit event
      this.form.addEventListener('submit', (event) => {
        this.onSubmitHandler(event);
      });

      // Get the submit buttom
      this.submitButton = this.form.querySelector('[data-product-set]');
      this.submitButton.addEventListener('click', (event)=> {
        this.onSubmitHandler(event);
      });

      // Get the product info from the context
      this.productInfo = this.closest('product-info');

      // Get variant selector
      this.variantSelectors = this.productInfo.querySelectorAll('input[type="radio"]');

      // Listen for changes
      let self = this;
      this.variantSelectors.forEach((variant) => {
        variant.addEventListener('change', this.onChangeHandler.bind(self));
      });

    }

    /**
     * renderContents
     * @description Renders the response from the section rendering api.
     * @param {Object} parsedState. Json object returned from section rendering api.
     */
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section) => {
        if (section?.selector) {
          const selector = document.querySelector(section.selector);
          if (selector) {
            selector.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.id],
              section.selector
            );
          }
        }
      });
    }

    /**
     * getSectionsToRender
     * @description Select and replace where to render the new html.
     * @returns Array
     */
    getSectionsToRender() {
      return [
        {
          id: 'cart-icon-bubble',
          selector: '[data-cart-icon-bubble]',
        },
      ];
    }

    /**
     * getSectionInnerHTML
     * @param {Nodes} html
     * @param {String} selector
     * @returns {Nodes}
     */
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    /**
     * onChangeHandler
     * @param {Object} variant selector
     */
    onChangeHandler(event) {
      let index = event.target.dataset.index;
      let set_product_ids = document.querySelector('product-sets .no-js-hidden input[name="set-' + index + '"]').value;
      let atc = document.querySelector('[data-product-set]');
      atc.dataset.productSet = set_product_ids;
    }

    /**
     * onSubmitHandler
     * @description Add the products on form submit event.
     * @param {Object} event
     */
    onSubmitHandler(event) {
      event.preventDefault();

      const submitButton = this.form.querySelector('button[name="add"]');

      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');

      let variantIds = submitButton.dataset.productSet;

      let sectionsToFetch = [];
      if (this.cartDrawer) {
        sectionsToFetch = this.cartDrawer.getSectionsToRender().map((section) => section.id);
      } else {
        sectionsToFetch = this.getSectionsToRender().map((section) => section.id);
      }

      let items = [];
      let variant_arr = variantIds.split(',');

      variant_arr.forEach(function(variant_str) {

        let variant_data = variant_str.split(':');
        let variant_id = variant_data[0];
        let variant_quantity = variant_data[1] || 1;
        let object = {};
        object = {
          quantity: variant_quantity,
          id: parseFloat(variant_id),
          sections: sectionsToFetch,
          sections_url: window.location.pathname,
          properties: {
            "_product_set": variantIds
          }
        }
        items.push(object);
      });

      let body = JSON.stringify({
        items: items
      });

      fetch(`${routes.cart_add_url}`, {...fetchConfig(), ...{ body }})
        .then((response) => response.json())
        .then((parsedState) => {

          if(this.quickshopDrawer) {
            this.quickshopDrawer.close();
          }

          // When quantity error
          if (parsedState.status == 422 && this.cartNotification) {
            this.cartNotification.setActiveElement(document.activeElement);
            this.cartNotification.renderQuantityError(formData.get('inventory_quantity'));
            return;
          }

          if (this.cartDrawer) {
            this.renderContents(parsedState);
            this.cartDrawer.renderContents(parsedState);
          }

          switch (submitButton.dataset.addToCartBehavior) {
            case ('open_cart_drawer'):

              if (this.cartDrawer) {
                this.cartDrawer.open();
              }
              break;
            case ('show_cart_notification'):
              if (this.cartNotification) {
                this.cartNotification.setActiveElement(document.activeElement);
                this.cartNotification.renderContents(parsedState);
              }
              break;
            default:
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('disabled');
        });
    }
  }

  window.ProductSets = ProductSets;
  customElements.define('product-sets', ProductSets);
}